// Language each markdown page is actually written in, per locale, collected by
// md2html.sh. A locale without its own file shows the other language's file.
import lang from '@/assets/generated/lang.json'

export default function isWrittenIn(slug, locale) {
  const l = locale === 'de' ? 'de' : 'en'
  return (lang[`${slug}.${l}`] || l) === l
}
